import React from 'react';
import { Element } from 'react-scroll';
import { motion } from 'framer-motion';
import HeroModern from './HeroModern';
import HomeContent from './HomeContent';
import Navbar from './Navbar';
import SakuraParticles from './SakuraParticles';
import AboutUs from '../pages/AboutUs'; // Reusing existing content
import Academic from '../pages/Academic';
import NewsSection from './NewsSection';
import ContactUs from '../pages/ContactUs';
import Footer from './Footer';

const MainLayout = () => {
  return (
    <div className="main-layout">
      <Navbar />

      {/* Global Background Particles - Over background, under content */}
      {/* Global Background Particles - Over background, under content */}
      {/* Global Foreground Overlay - Sakura Particles over everything */}
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, pointerEvents: 'none' }}>
        <SakuraParticles count={50} />
      </div>

      {/* Global Background - Tree Image only */}
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: -10 }}>
        {/* Tree Image Layer - fixed to left side */}
        <img
          src={require('./main_images/a2.png')}
          alt="Tree Background"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '85vh',
            width: 'auto',
            zIndex: -1,
            pointerEvents: 'none',
            objectFit: 'contain'
          }}
        />
      </div>

      <Element name="home">
        <HeroModern />
        <HomeContent />
      </Element>

      <Element name="academic">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="section"
          style={{ backgroundColor: 'rgba(250, 250, 250, 0.8)', position: 'relative', zIndex: 1 }}
        >
          <Academic isSection={true} />
        </motion.div>
      </Element>

      {/* <Element name="newsfeed">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="section"
          style={{ position: 'relative', zIndex: 1 }}
        >
          <NewsSection />
        </motion.div>
      </Element> */}

      <Element name="about">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="section"
          style={{ position: 'relative', zIndex: 1 }}
        >
          <AboutUs isSection={true} />
        </motion.div>
      </Element>

      <Element name="contactus">
        <motion.div
          className="section"
          style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(252, 233, 242, 0.9) 100%)', position: 'relative', zIndex: 1 }}
        >
          <ContactUs isSection={true} />
        </motion.div>
      </Element>

      <Footer />
    </div>
  );
};

export default MainLayout;
